import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BiaUtils } from 'src/@utility/bia.utils';
import * as fromBia from './bia.reducer';
import { BiaState } from './bia.state';

export const selectBiaState = createFeatureSelector<BiaState>(
  fromBia.biaFeatureKey
);

export const getAllBias = createSelector(
  selectBiaState,
  (state) => state.allBias
);

export const getBias = createSelector(selectBiaState, (state) => ({
  bias: state.bias,
  count: state.count,
}));

export const getBia = createSelector(getBias, (data, props) => {
  return data.bias.find((bia) => bia.id == props.id);
});

export const getCallTrees = createSelector(selectBiaState, (state, props) => {
  return state.callTrees[props.id];
});

function filterAppCallTree(cts, props) {
  return cts
    ? cts.filter((ct) =>
        BiaUtils.filterTabData(ct, props.depends, 'find', true)
      )
    : [];
}

export const getApplicableCallTrees = createSelector(
  getCallTrees,
  (cts, props) => {
    return filterAppCallTree(cts, props);
  }
);

export const getCallTreeMultiple = createSelector(
  selectBiaState,
  (state, props) => {
    const act = [];
    props.ids.forEach((id) => {
      state.callTrees[id] && act.push(state.callTrees[id]);
    });
    return act;
  }
);
export const getApplicableCallTreeMultiple = createSelector(
  selectBiaState,
  (state, props) => {
    const act = [];
    props.ids.forEach((id) => {
      act.push(filterAppCallTree(state.callTrees[id], props));
    });
    return act;
  }
);

export const getProcesses = createSelector(selectBiaState, (state, props) => {
  return state.processes[props.id];
});
export const getImpact = createSelector(selectBiaState, (state, props) => {
  return state.impacts[props.id];
});

export const getInDependencies = createSelector(
  selectBiaState,
  (state, props) => {
    return state.inDependencies[props.id];
  }
);

export const getExDependencies = createSelector(
  selectBiaState,
  (state, props) => {
    return state.exDependencies[props.id];
  }
);

export const getBiaPeakTimes = createSelector(
  selectBiaState,
  (state, props) => {
    return state.peakTimes[props.id];
  }
);
export const getBiaDeadLines = createSelector(
  selectBiaState,
  (state, props) => {
    return state.deadLines[props.id];
  }
);

export const getAdInfo = createSelector(selectBiaState, (state, props) => {
  return state.adInfo[props.id];
});

export const getVitalRecord = createSelector(selectBiaState, (state, props) => {
  return state.vitalRecord[props.id];
});

export const getItInfra = createSelector(selectBiaState, (state, props) => {
  return state.itInfraRquire[props.id];
});

export const getSpleReq = createSelector(selectBiaState, (state, props) => {
  return state.splReq[props.id];
});

export const getAppNSoft = createSelector(selectBiaState, (state, props) => {
  return state.appNSoft[props.id];
});

export const getStaffReq = createSelector(selectBiaState, (state, props) => {
  return state.staffReq[props.id];
});

export const getSpof = createSelector(selectBiaState, (state, props) => {
  return state.spof[props.id];
});

export const getHR = createSelector(selectBiaState, (state, props) => {
  return state.hr[props.id];
});

export const getResourceCallTree = createSelector(
  selectBiaState,
  (state, props) => {
    return state.resourceCallTree[props.id];
  }
);

export const getBiaIntro = createSelector(selectBiaState, (state, props) => {
  return state.biaIntro[props.biaId];
});
